export const KIND_ICONS = {
  home: 'icon-home',
  work: 'icon-dpto',
  couple: 'icon-heart',
  other: 'icon-location2',
  location: 'icon-location'
};
